import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Alte Hash-Links (z. B. /#/musik?titel=27) auf saubere Pfade umschreiben,
// damit bereits geteilte Links weiter funktionieren.
if (window.location.hash.startsWith('#/')) {
  window.history.replaceState(null, '', window.location.hash.slice(1));
}

createRoot(document.getElementById('root')).render(
<StrictMode>
    <App />
</StrictMode>
);